export const TOOLS = [
  {
    slug: 'renovation-planner',
    name: 'Renovation Project Planner',
    short: 'Planner',
    what: 'A guided seven-step experience that turns a vague project idea into an organized renovation plan.',
  who: 'Homeowners at the very beginning, before the first contractor conversation.',
    gets: 'A personalized planning summary, a priorities checklist matched to your project, and a clear next step.',
    image: '/images/interior-3.jpg',
    alt: 'Beautifully renovated living space representing a planned renovation project',
    resource: { slug: 'renovation-planning-checklist', label: 'Renovation Planning Checklist' },
    icon: 'Map',
  },
  {
    slug: 'compare-renovation-quotes',
    name: 'Compare Renovation Quotes',
    short: 'Quote Comparison',
  what: 'A structured side-by-side comparison of up to three renovation quotes: scope, materials, timeline, terms.',
    who: 'Homeowners holding two or more quotes and wanting to compare more than the final number.',
    gets: 'A clear comparison table, missing-information flags, and differences worth reviewing.',
    image: '/images/blueprint-1.jpg',
    alt: 'Renovation plans and drawings laid out for review',
    resource: { slug: 'how-to-compare-renovation-quotes', label: 'How to Compare Renovation Quotes' },
    icon: 'GitCompareArrows',
  },
  {
    slug: 'renovation-budget-planner',
    name: 'Renovation Budget Planner',
    short: 'Budget Planner',
    what: 'An allocation tool that organizes your planned budget across materials, labour, design, other costs and contingency.',
    who: 'Homeowners who know their number and want to organize it before quotes arrive.',
    gets: 'A visual budget allocation, remaining-balance tracking, and an organized summary to bring to quote conversations.',
    image: '/images/interior-5.jpg',
    alt: 'Renovated bedroom with dark feature wall, representing a budgeted renovation project',
    resource: { slug: 'renovation-budget-planning', label: 'How to Plan Your Renovation Budget' },
    icon: 'Wallet',
  },
  {
    slug: 'contractor-checklist',
    name: 'Contractor Checklist',
    short: 'Contractor Checklist',
  what: 'An interactive review checklist across eight categories: from experience and scope to payment, warranty and communication.',
    who: 'Homeowners evaluating renovation professionals before signing anything.',
    gets: 'A complete, organized review record you can check off, print and bring to every quote conversation.',
    image: '/images/trades-1.jpg',
    alt: 'Tradesperson wiring an electrical box on a renovation site',
    resource: { slug: 'how-to-choose-a-contractor', label: 'How to Choose a Renovation Contractor' },
    icon: 'BadgeCheck',
  },
  {
    slug: 'renovation-checklist',
    name: 'Renovation Planning Checklist',
    short: 'Planning Checklist',
  what: 'A six-stage project roadmap (define, plan, quotes, select, prepare, project) with progress that saves as you go.',
    who: 'Homeowners who want the whole renovation organized in one place, from idea to completion.',
    gets: 'Overall and per-stage progress, a satisfying check-off experience, and a project that stays organized.',
    image: '/images/interior-9.jpg',
    alt: 'Bright renovated interior at the completion of an organized project',
    resource: { slug: 'renovation-timeline', label: 'Renovation Timeline Guide' },
    icon: 'ListChecks',
  },
];

export const getTool = (slug) => TOOLS.find((t) => t.slug === slug);
